import { OrthographicCamera } from "three";
import { PerspectiveCamera } from "three";

export class BasicCamera extends PerspectiveCamera {
    constructor(container = document.querySelector('body')) {
        super(75, container.clientWidth / container.clientHeight, 0.1, 1000);
        this.position.z = 5;
        this.position.y = 2;
    }
}

export class IsometricCamera extends OrthographicCamera {
    constructor(container = document.querySelector('body'), frustumSize = 20) {
        const aspect = container.clientWidth / container.clientHeight;
        super(0.5 * frustumSize * aspect  / - 2, 0.5 * frustumSize * aspect / 2, 0.5 * frustumSize / 2, 0.5 * frustumSize / - 2);
        this.frustumSize = frustumSize;
        this.position.x = 25;
        this.position.z = 25;
        this.position.y = 25;
    }
}